import React, { FC, useState } from 'react';

import AccountTypeRadioOption from './AccountTypeRadioOption';
import CapabilityList from './CapabilityList';
import { RadioGroupOption } from './acl-types';
import { getAccountTypeOptions } from './acl-util';
import { Group, Permission } from '../../../api/gql/graphql';

// @tecton
import { FlexItem } from '@tecton/ComponentRedesign';
import { FlexGroupWrapper } from '../../@tecton/ComponentRedesign/StyledComponents';

interface ModifyAccountTypeProps {
  group?: Group;
  selectedAccountType?: string;
  roleDescriptionMap: Record<string, Permission[]>;
  onSelectionClicked: (selectedAccountType: string /** undefined means the selection didn't change */) => void;
}

const ModifyGroupAccountType: FC<ModifyAccountTypeProps> = ({
  group,
  selectedAccountType,
  roleDescriptionMap,
  onSelectionClicked,
}) => {
  const accountType = selectedAccountType ?? group?.accountType ?? 'Regular';
  const options = getAccountTypeOptions(accountType);
  const [accountTypeOptions, setAccountTypeOptions] = useState<RadioGroupOption[]>(options);
  const [roleDescription, setRoleDescription] = useState<Permission[]>(roleDescriptionMap[accountType]);

  return (
    <>
      <FlexGroupWrapper gap="xl" direction="column">
        <FlexItem>
          <FlexGroupWrapper gap="l" direction="row">
            <FlexItem grow={4}>
              <AccountTypeRadioOption
                options={accountTypeOptions}
                onSelection={(selectedOption) => {
                  const options = getAccountTypeOptions(selectedOption.id);
                  setAccountTypeOptions(options);
                  setRoleDescription(roleDescriptionMap[selectedOption.id]);
                  onSelectionClicked(selectedOption?.id);
                }}
              />
            </FlexItem>
            <FlexItem grow={5}>
              <CapabilityList roleDescriptions={roleDescription} />
            </FlexItem>
          </FlexGroupWrapper>
        </FlexItem>
      </FlexGroupWrapper>
    </>
  );
};

export default ModifyGroupAccountType;
